document.addEventListener("DOMContentLoaded", () => {
    // Sécurité GSAP
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Injection du CSS pour le curseur clignotant
    // (Pour garder le plugin autonome sans dépendre d'un fichier style.css)
    const styleTag = document.createElement("style");
    styleTag.textContent = `
        .passeuse-text-reveal-wrapper p {
            display: inline;
            position: relative;
        }
        .passeuse-text-reveal-wrapper p.is-typing::after {
            content: '|';
            margin-left: 2px;
            font-weight: bold;
            color: inherit;
            animation: blinkCursor 0.75s step-end infinite;
        }
        @keyframes blinkCursor {
            from, to { opacity: 1; }
            50% { opacity: 0; }
        }
    `;
    document.head.appendChild(styleTag);

    const revealBlocks = document.querySelectorAll('.passeuse-text-reveal-wrapper');

    revealBlocks.forEach(block => {
        const paragraph = block.querySelector('p');
        if (!paragraph) return;

        // Récupération des données
        const startColor = block.getAttribute('data-start-color') || '#e0e0e0';
        // Vitesse par défaut de 0.03 si absent
        const animationSpeed = parseFloat(block.getAttribute('data-animation-speed')) || 0.03;
        const animationType = block.getAttribute('data-animation-type') || 'reveal';
        
        const computedStyle = window.getComputedStyle(paragraph);
        const endColor = computedStyle.color;

        const texteOriginal = paragraph.textContent;
        paragraph.textContent = "";

        // ==========================================
        // CAS 1 : Animation de Révélation (Couleur)
        // ==========================================
        if (animationType === 'reveal') {
            const tableauCaracteres = texteOriginal.split("");
            
            tableauCaracteres.forEach(caractere => {
                if (caractere === " ") { 
                    paragraph.appendChild(document.createTextNode(" "));
                } else {
                    const span = document.createElement("span");
                    span.textContent = caractere;
                    span.style.color = startColor;
                    paragraph.appendChild(span);
                }
            });

            const tousLesSpans = paragraph.querySelectorAll("span");

            gsap.to(tousLesSpans, {
                color: endColor,
                duration: animationSpeed * 2, 
                stagger: animationSpeed, // <--- La vitesse est liée ici (délai entre lettres)
                ease: "none",
                scrollTrigger: {
                    trigger: paragraph,
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            });
        }

        // ==========================================
        // CAS 2 : Animation Machine à écrire
        // ==========================================
        else if (animationType === 'typewriter') {
            // Sécurité TextPlugin
            if (typeof window.TextPlugin === 'undefined') {
                console.error("Erreur : GSAP TextPlugin n'est pas chargé.");
                paragraph.textContent = texteOriginal;
                return;
            }
            
            gsap.registerPlugin(window.TextPlugin);

            paragraph.style.color = endColor;

            // Animation GSAP avec classe CSS pour le curseur
            gsap.to(paragraph, {
                duration: animationSpeed * 2 * texteOriginal.length, // Durée totale
                text: {
                    value: texteOriginal,
                    delimiter: ""
                },
                ease: "none",
                onStart: () => {
                    // On ajoute le curseur clignotant
                    paragraph.classList.add('is-typing');
                },
                onComplete: () => {
                    // On supprime le curseur à la fin
                    paragraph.classList.remove('is-typing');
                },
                scrollTrigger: {
                    trigger: paragraph,
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            });
        }
    });
});